<app-pre-activation
        *ngIf="!activated && !isLoading"
        [textDefault]="textDefault"
        [isLoading]="isLoading"
        (activationStarted)="activate()">
</app-pre-activation>

<app-confirmation-preloader *ngIf="!activated && isLoading"></app-confirmation-preloader>

<app-post-activation
        *ngIf="activated && !isLoading"
        (retry)="retryActivation()"
        [activationError]="activationError"
        [error]="error">
</app-post-activation>
